import { IContratosGerados } from "../../../Interfaces/Geral/ContratosGerados/ContratosGeradosInterface";
import { GetContratoPorCasoService, ListaContratoStatusService, AtualizaContratoService, ExportHTMLtoPDFService } from "../../../Services/Geral/ContratosGerados/ContratosGeradosService";
import { Controller } from "../../Controller";


export function GetContratoPorCasoController(idCaso: number){
    return Controller(
        GetContratoPorCasoService(idCaso)
    )
}

export function ListaContratoStatusController(){
    return Controller(
        ListaContratoStatusService()
    )
}

export function AtualizaContratoController(responseBody: IContratosGerados){
    return Controller(
        AtualizaContratoService(responseBody)
    )
}

export function ExportHTMLtoPDFController(requestBody: {strHTML: string}){
    return Controller(
        ExportHTMLtoPDFService(requestBody)
    )
}
